$(document).ready(function () {
    "use strict";

    $(document).on('click', '.js_doneFiltering', function(e) {
        e.preventDefault();

        $('.searchFilter').removeClass('active');

        $('.element').removeClass('activePopup').find('.popup').hide();

        setTimeout(function() {

            $('.searchFilter').animate({
                scrollTop: $('.searchFilter').offset().top
            }, 0, function() {
                $('html').removeClass('filterActive');
            });

        }, 300)
    });

    $(document).on('mousedown touchstart', function (e) {

        var menu = $('#filter');

        if ($('html').hasClass('filterActive') && !menu.is(e.target) && menu.has(e.target).length == 0) {

            $('.searchFilter').removeClass('active');

            $('.element').removeClass('activePopup').find('.popup').hide();

            setTimeout(function() {

                $('.searchFilter').animate({
                    scrollTop: $('.searchFilter').offset().top
                }, 0, function() {
                    $('html').removeClass('filterActive');
                });

            }, 300)
        }
    });

    document.addEventListener('touchmove',function (){
        if ($('html').hasClass('filterActive')) {
            document.body.scrollTop = 0;
        }
    })
});